import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "imageRef", "placeholderHeight", "placeholderWidth", "src", "testId", "onImageLoad", "onLoad"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useTestId from '@ori/testid-generator';
import { useEffect, useCallback, useState } from 'react';
import { Img } from "./styles";
import { LAZY_IMAGE } from "../../common";
import { ImagePlaceholder } from "../ImagePlaceholder";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LazyImage = function LazyImage(_ref) {
  var alt = _ref.alt,
    imageRef = _ref.imageRef,
    placeholderHeight = _ref.placeholderHeight,
    placeholderWidth = _ref.placeholderWidth,
    src = _ref.src,
    testId = _ref.testId,
    onImageLoad = _ref.onImageLoad,
    onLoad = _ref.onLoad,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaceholderVisible = _useState2[0],
    setIsPlaceholderVisible = _useState2[1];
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var handleLoad = useCallback(function (e) {
    setIsPlaceholderVisible(false);
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(e);
  }, [onLoad]);
  var handleLoadEvent = useCallback(function () {
    onImageLoad === null || onImageLoad === void 0 ? void 0 : onImageLoad();
  }, [onImageLoad]);
  useEffect(function () {
    var lazyImageElement = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current;
    lazyImageElement === null || lazyImageElement === void 0 ? void 0 : lazyImageElement.addEventListener('load', handleLoadEvent);
    return function () {
      lazyImageElement === null || lazyImageElement === void 0 ? void 0 : lazyImageElement.removeEventListener('load', handleLoadEvent);
    };
  }, [handleLoadEvent, imageRef]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isPlaceholderVisible ? /*#__PURE__*/_jsx(ImagePlaceholder, {
      isLoadingPlaceholder: true,
      isSquare: placeholderHeight === undefined && placeholderWidth === undefined,
      height: placeholderHeight,
      width: placeholderWidth
    }) : null, /*#__PURE__*/_jsx(Img, _objectSpread({
      ref: imageRef,
      alt: alt !== null && alt !== void 0 ? alt : src,
      src: src,
      "data-testid": testId !== null && testId !== void 0 ? testId : getTestId(LAZY_IMAGE),
      role: "presentation",
      isPlaceholderVisible: isPlaceholderVisible,
      onLoad: handleLoad
    }, restProps))]
  });
};
//# sourceMappingURL=LazyImage.js.map